import React from "react";
import { motion } from "framer-motion";
import { MapPin, Clock } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function InaugurationBanner() {
  const { lang } = useLang();
  const isCA = lang === "ca";

  const headline = isCA ? "JA ESTEM OBERTS" : "YA ESTAMOS ABIERTOS";
  const hours = isCA ? "De 5:00h a 1:00h · 365 dies l'any" : "De 5:00h a 1:00h · 365 días al año";
  const noHolidays = isCA ? "Sense festius · Sense excuses" : "Sin festivos · Sin excusas";

  return (
    <section
      id="gym-banner"
      data-testid="gym-banner"
      className="relative overflow-hidden"
      style={{ minHeight: "100vh" }}
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/gym-banner.png')" }}
      />

      {/* Dark translucent overlay */}
      <div
        className="absolute inset-0"
        style={{ background: "rgba(0,0,0,0.55)" }}
      />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 sm:px-6 lg:px-8 pt-28 pb-16 text-center">

        {/* Live badge */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="inline-flex items-center gap-2 bg-[#FFCC00] text-black text-[11px] font-black tracking-[0.25em] uppercase px-4 py-1.5 mb-8"
          data-testid="open-badge"
        >
          <span className="w-2 h-2 rounded-full bg-black animate-pulse" />
          {isCA ? "OBERT ARA" : "ABIERTO AHORA"}
        </motion.div>

        {/* Main headline */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, delay: 0.1 }}
          className="font-black leading-none text-white text-5xl sm:text-7xl lg:text-[7.5rem] tracking-tight mb-6"
          data-testid="gym-banner-headline"
        >
          {headline}
        </motion.h2>

        {/* Hours */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.25 }}
          className="flex flex-col items-center gap-2 mb-8"
        >
          <div className="inline-flex items-center gap-3 text-[#FFCC00] text-xl sm:text-2xl font-black tracking-wide">
            <Clock size={22} className="shrink-0" />
            <span>{hours}</span>
          </div>
          <p className="text-white/50 text-sm tracking-[0.2em] uppercase font-bold">
            {noHolidays}
          </p>
        </motion.div>

        {/* Address */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.38 }}
          className="inline-flex items-center gap-2 border border-white/20 bg-white/5 backdrop-blur-sm px-5 py-2.5"
          data-testid="gym-banner-address"
        >
          <MapPin size={15} className="text-[#FFCC00] shrink-0" />
          <span className="text-sm font-bold tracking-wide text-white/80">
            Carrer Sils, 17 · 17411 Vidreres, Girona
          </span>
        </motion.div>

      </div>
    </section>
  );
}
